// avstemming-general-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'ava.common.notCompared': 'Sin comparar',
  'ava.common.enterAmount': 'Escribe un importe.',
  'ava.common.date': 'Fecha',
  'ava.common.amount': 'Importe',
  'ava.common.remove': 'Quitar',
  'ava.common.add': 'Añadir',
  'ava.common.account': 'Cuenta',
  'ava.common.status': 'Estado',
  'ava.common.requestDocs': 'Solicitar documentación',
  'ava.common.close': 'Cerrar',
  'ava.common.cancel': 'Cancelar',
  'ava.common.source': 'Origen',
  'ava.common.type': 'Tipo',
  'ava.common.voucher': 'Justificante',
  'ava.common.description': 'Descripción',
  'ava.common.fileNotFound': 'No se encontró el archivo en el almacenamiento.',
  'ava.status.notChecked': 'Sin revisar',
  'ava.status.ok': 'OK',
  'ava.status.deviation': 'Desviación',
  'ava.status.notRelevant': 'No aplica',
  'ava.item.class.timing': 'Diferencia temporal',
  'ava.item.class.missingVoucher': 'Justificante faltante',
  'ava.item.class.misposting': 'Error de contabilización',
  'ava.item.class.unidentified': 'Sin identificar',
  'ava.item.class.other': 'Otro',
  'ava.item.action.none': 'Ninguna',
  'ava.item.action.followUp': 'Dar seguimiento el próximo periodo',
  'ava.item.action.createAdjustment': 'Crear justificante de corrección',
  'ava.item.action.requestDocs': 'Pedir documentación al cliente',
  'ava.account.bookedBalance': 'Saldo contabilizado',
  'ava.diff.externalBalance': 'Saldo externo',
  'ava.diff.notEntered': 'No introducido',
  'ava.diff.preliminary': 'Diferencia preliminar',
  'ava.diff.explainedItems': 'Partidas explicadas',
  'ava.diff.unexplained': 'Diferencia sin explicar',
  'ava.items.reasonRequired': 'Escribe a qué se debe la partida. Sin justificación no cuenta como explicada.',
  'ava.items.title': 'Partidas de conciliación',
  'ava.items.colReason': 'A qué se debe la partida',
  'ava.items.colClassification': 'Clasificación',
  'ava.items.colAction': 'Medida',
  'ava.items.missingReason': 'Falta la justificación',
  'ava.items.followUpDue': 'Fecha límite de seguimiento',
  'ava.items.voucherBasis': 'Base del justificante',
  'ava.items.markUnresolved': 'Marcar como sin resolver',
  'ava.items.markResolved': 'Marcar como resuelta',
  'ava.items.reasonPlaceholder': '¿A qué se debe la partida?',
  'ava.account.backTo': 'Volver a {area}',
  'ava.account.basisChanged': 'El saldo contabilizado ha cambiado desde que se concilió la cuenta. La base ya no es la misma.',
  'ava.account.reconciledAgo': 'conciliada {when}',
  'ava.account.accountingData': 'Datos contables',
  'ava.account.area': 'Área',
  'ava.account.lastUpdated': 'Última actualización',
  'ava.account.reconciledAgainst': 'Conciliada contra',
  'ava.account.bookedBalanceNote': 'El saldo contabilizado se toma del balance de comprobación que calcula la app. Si cambia la contabilidad, la cifra se actualiza.',
  'ava.account.externalBasis': 'Base externa',
  'ava.account.externalBalance': 'Saldo externo',
  'ava.account.externalBalanceOptional': 'Saldo externo (opcional aquí)',
  'ava.account.externalBalancePlaceholder': 'Ej. 124 500,00',
  'ava.account.externalBalanceNumber': 'El saldo externo debe ser un número.',
  'ava.account.documentDate': 'Fecha del documento',
  'ava.account.source': 'Origen',
  'ava.account.sourcePlaceholder': 'Ej. extracto de cuenta de DNB, obtenido el 03.09',
  'ava.account.reference': 'Referencia',
  'ava.account.referencePlaceholder': 'Ej. número de extracto o referencia del justificante',
  'ava.account.docsLinkedOne': '{count} documento está vinculado a la cuenta.',
  'ava.account.docsLinkedMany': '{count} documentos están vinculados a la cuenta.',
  'ava.account.docsNone': 'No hay documentos vinculados a la cuenta. Sube uno en el panel de la derecha o escribe una nota abajo.',
  'ava.account.documentNote': 'Nota adicional sobre la documentación',
  'ava.account.documentNotePlaceholder': 'Ej. «Extracto de cuenta descargado el 03.09»',
  'ava.account.differenceCalc': 'Cálculo de la diferencia',
  'ava.account.conclusion': 'Conclusión',
  'ava.account.conclusionPlaceholder': '¿Qué muestra la conciliación y en qué se basa la conclusión?',
  'ava.account.remainingRisk': 'Riesgo restante',
  'ava.account.remainingRiskPlaceholder': 'Ej. ninguno',
  'ava.account.followUp': 'Seguimiento del próximo periodo',
  'ava.account.followUpPlaceholder': 'Ej. dar seguimiento a un cobro sin identificar',
  'ava.account.statusChecked': 'Revisada',
  'ava.account.statusReconciled': 'Conciliada',
  'ava.area.counts': '{approved} de {total} conciliadas · {deviations} desviaciones · {missing} sin documentación',
  'ava.area.noExternalNeeded': 'no requiere base externa',
  'ava.area.sendToControl': 'Enviar el área a revisión',
  'ava.area.noAccounts': 'Aún no se ha añadido ninguna cuenta a esta área. Abre una cuenta en «Resto del balance» y muévela aquí.',
  'ava.area.colBooked': 'Contabilizado',
  'ava.area.colExternal': 'Externo',
  'ava.area.colUnexplained': 'Sin explicar',
  'ava.area.colDocumentation': 'Documentación',
  'ava.area.changedAfterReconciliation': 'Modificada tras la conciliación',
  'ava.area.attached': 'Adjunta',
  'ava.area.missing': 'Falta',
  'ava.ctx.guide.bank': 'Saldo contabilizado frente al extracto bancario al cierre del periodo. Las partidas del banco no contabilizadas y las partidas contabilizadas que no están en el banco deben explicarse.',
  'ava.ctx.guide.kundefordringer': 'Libro mayor frente al auxiliar de clientes. Las partidas abiertas deben poder detallarse por cliente y los créditos antiguos deben evaluarse por posibles pérdidas.',
  'ava.ctx.guide.leverandorgjeld': 'Libro mayor frente al auxiliar de proveedores. Las facturas recibidas que no están contabilizadas pertenecen al periodo al que se refieren.',
  'ava.ctx.guide.payroll': 'Las cuentas de nómina frente al diario de nómina y la a-melding: salarios pendientes de pago, vacaciones y cotización del empleador devengada.',
  'ava.ctx.guide.mva': 'Las cuentas de IVA frente a la declaración de IVA del periodo. La base y el impuesto deben ser coherentes, y la cuenta de liquidación debe quedar a cero tras el pago.',
  'ava.ctx.guide.skatt': 'Retención de impuestos, cotización del empleador e impuesto a pagar frente a la a-melding y la liquidación de Skatteetaten. La retención debe permanecer en su propia cuenta hasta que se pague.',
  'ava.ctx.guide.assets': 'Activos capitalizados frente al registro de activos fijos: adquisiciones, bajas y amortizaciones del periodo.',
  'ava.ctx.guide.lan': 'Préstamos frente al estado del préstamo: el saldo inicial, las disposiciones, las amortizaciones y los intereses devengados deben cuadrar con el saldo final.',
  'ava.ctx.guide.egenkapital': 'Patrimonio neto frente a los acuerdos de la junta general: resultado del ejercicio, dividendos y otras distribuciones.',
  'ava.ctx.guide.other': 'Resto de cuentas del balance. Cada cuenta debe tener un detalle que muestre en qué consiste el saldo.',
  'ava.ctx.guide.periodekontroll': 'Las revisiones que afectan a todo el periodo: que todos los justificantes estén contabilizados, que se hayan hecho las periodificaciones y que los informes sean coherentes.',
  'ava.ctx.term': 'Periodo',
  'ava.ctx.deadline': 'Plazo {date}',
  'ava.ctx.outputVat': 'IVA repercutido',
  'ava.ctx.inputVat': 'IVA soportado',
  'ava.ctx.refundable': 'A devolver',
  'ava.ctx.payable': 'A pagar',
  'ava.ctx.filed': 'La declaración está presentada',
  'ava.ctx.notFiled': 'La declaración no está presentada',
  'ava.ctx.activeAssets': 'Activos en uso',
  'ava.ctx.inAssetRegister': 'En el registro de activos fijos',
  'ava.ctx.soldThisYear': 'Vendidos este año',
  'ava.ctx.writtenOffThisYear': 'Dados de baja este año',
  'ava.ctx.statementsLoaded': 'Extractos de cuenta cargados',
  'ava.ctx.inBankView': 'En la vista de banco',
  'ava.ctx.unmatchedLines': 'Líneas bancarias sin vincular',
  'ava.ctx.totalNotOnlyPeriod': 'Total, no solo de este periodo',
  'ava.ctx.unpaidInvoices': 'Facturas sin pagar',
  'ava.ctx.statusToday': 'Estado a día de hoy, no al cierre del periodo',
  'ava.ctx.outstandingAmount': 'Importe pendiente',
  'ava.ctx.title': 'Base de la contabilidad',
  'ava.ctx.footnote': 'Las cifras son las de la propia contabilidad, tomadas de las vistas que las gestionan. Ayudan a localizar la base, pero no son una base externa en sí mismas, por lo que no se rellenan como saldo externo.',
  'ava.ledger.age.d0to30': '0–30 días',
  'ava.ledger.age.d31to60': '31–60 días',
  'ava.ledger.age.d61to90': '61–90 días',
  'ava.ledger.age.over90': 'Más de 90 días',
  'ava.ledger.age.noDate': 'Sin fecha',
  'ava.ledger.title': 'Asientos del periodo',
  'ava.ledger.allAccounts': 'Todas las cuentas del área',
  'ava.ledger.onlyOld': 'Solo con más de 60 días',
  'ava.ledger.colText': 'Texto',
  'ava.ledger.colAge': 'Antigüedad',
  'ava.ledger.noMatch': 'Ningún asiento coincide con el filtro.',
  'ava.ledger.noLines': 'No hay asientos en las cuentas del área en este periodo.',
  'ava.check.critical': 'Crítico',
  'ava.check.reasonRequired': 'Se requiere justificación',
  'ava.check.reason': 'Justificación',
  'ava.check.reasonPlaceholder': '¿Cuál es la desviación y qué se hace al respecto?',
  'ava.check.defaultGroup': 'Puntos de control',
  'ava.check.title': 'Lista de comprobación profesional',
  'ava.check.titleReadOnly': 'Lista de comprobación profesional (de quien la realiza, solo lectura)',
  'ava.check.noItems': 'No hay puntos de control definidos para esta área.',
  'ava.check.progress': '{done} de {total} puntos evaluados. El programa es propio del despacho: indica qué se debe revisar, no qué está permitido.',
  'ava.check.assessedAgo': 'Evaluado {when}',
  'ava.saldo.descriptionRequired': 'Escribe qué es la partida.',
  'ava.saldo.title': 'Detalle del saldo',
  'ava.saldo.intro': 'De qué partidas se compone el saldo. El total debe coincidir con el libro mayor.',
  'ava.saldo.colCounterparty': 'Contraparte',
  'ava.saldo.colFrom': 'Desde',
  'ava.saldo.colTo': 'Hasta',
  'ava.saldo.colDocument': 'Documento',
  'ava.saldo.descriptionPlaceholder': '¿Qué es la partida?',
  'ava.saldo.docRefPlaceholder': 'Justif./ref.',
  'ava.saldo.sum': 'Total del detalle',
  'ava.saldo.deviates': 'Difiere en {amount} del libro mayor',
  'ava.saldo.matchesLedger': 'Coincide con el libro mayor',
  'ava.rollforward.title': 'Conciliación acumulativa',
  'ava.rollforward.warning': 'El saldo final no cuadra con el saldo inicial y el movimiento del periodo. Lo que hay que revisar es el balance de comprobación, no la conciliación.',
  'ava.blocker.title': 'Aún no se puede marcar como conciliada',
  'ava.blocker.note': 'Las reglas se aplican en el backend. Corrige los puntos anteriores y el estado se habilitará por sí solo.',
  'ava.adjust.description': 'Corrección de conciliación {account} {period}',
  'ava.adjust.copyDescription': 'Descripción: {value}',
  'ava.adjust.copyAmount': 'Importe: {value}',
  'ava.adjust.copyAccount': 'Cuenta: {value}',
  'ava.adjust.copyDirection': 'Sentido: {value}',
  'ava.adjust.accountDown': 'La cuenta debe bajar',
  'ava.adjust.accountUp': 'La cuenta debe subir',
  'ava.adjust.copied': 'Se ha copiado la base. Pégala en un asiento manual.',
  'ava.adjust.copyFailed': 'No se pudo copiar. Anota las cifras de arriba a mano.',
  'ava.adjust.copyUnavailable': 'Copiar no está disponible aquí. Anota las cifras de arriba a mano.',
  'ava.adjust.title': 'Crear justificante de corrección',
  'ava.adjust.copyBasis': 'Copiar la base',
  'ava.adjust.period': 'Periodo',
  'ava.adjust.direction': 'Sentido',
  'ava.adjust.note': 'El justificante se contabiliza como asiento manual en la contabilidad, no aquí. Así recibe la misma validación, el mismo número de justificante y el mismo rastro de auditoría que todo lo demás que se contabiliza.',
  'ava.docs.kind.statement': 'Extracto de cuenta',
  'ava.docs.kind.balanceConfirmation': 'Confirmación de saldo',
  'ava.docs.kind.subledgerList': 'Listado del auxiliar',
  'ava.docs.kind.aMelding': 'A-melding',
  'ava.docs.kind.vatReturn': 'Declaración de IVA',
  'ava.docs.kind.agreement': 'Contrato',
  'ava.docs.kind.other': 'Otro',
  'ava.docs.req.waiting': 'Esperando respuesta',
  'ava.docs.req.answered': 'Respondida',
  'ava.docs.req.closed': 'Cerrada',
  'ava.docs.loading': 'Obteniendo el documento …',
  'ava.docs.unsupportedType': 'Este tipo de archivo no se puede mostrar aquí.',
  'ava.docs.openInNewTab': 'Abrir en una pestaña nueva',
  'ava.docs.size': 'Tamaño',
  'ava.docs.fromClient': 'Del cliente',
  'ava.docs.uploadedByFirm': 'Subido por el despacho',
  'ava.docs.uploadedBy': 'Subido por',
  'ava.docs.time': 'Fecha y hora',
  'ava.docs.linkedTo': 'Vinculado a',
  'ava.docs.wholePeriod': 'Todo el periodo',
  'ava.docs.colUploaded': 'Subido',
  'ava.docs.sourceClient': 'El cliente',
  'ava.docs.sourceFirm': 'El despacho',
  'ava.docs.viewDocument': 'Ver documento',
  'ava.docs.noneForAccount': 'No hay documentos vinculados a esta cuenta.',
  'ava.docs.noneForPeriod': 'No hay documentos subidos en este periodo.',
  'ava.docs.preview': 'Vista previa',
  'ava.docs.open': 'Abrir',
  'ava.docs.documentType': 'Tipo de documento',
  'ava.docs.upload': 'Subir documento',
  'ava.docs.noRequests': 'No se han enviado solicitudes para este periodo.',
  'ava.docs.dueDate': 'Plazo de respuesta {date}',
  'ava.docs.noDueDate': 'Sin plazo de respuesta',
  'ava.docs.sentBy': 'enviada por {email}',
  'ava.docs.documentsReceived': '{count} documento recibido',
  'ava.docs.markAnswered': 'Marcar como respondida',
  'ava.docs.sendRequest': 'Enviar solicitud',
  'ava.docs.concerns': 'Se refiere a {account}',
  'ava.docs.subject': 'Asunto',
  'ava.docs.subjectPlaceholder': 'Ej. Extracto de cuenta de agosto',
  'ava.docs.whatDoYouNeed': 'Qué necesitan',
  'ava.docs.bodyPlaceholder': 'Describe qué falta y por qué se necesita',
  'ava.docs.requestedDocumentation': 'Documentación solicitada',
  'ava.docs.requestedDocumentationPlaceholder': 'Ej. extracto de cuenta del banco',
  'ava.docs.dueLabel': 'Plazo de respuesta',
  'ava.docs.requestNote': 'La solicitud se añade al diálogo que ustedes tienen con el cliente y permanece aquí hasta que se responda.',
  'ava.drawer.ariaLabel': 'Conciliación de {name}',
  'ava.drawer.org': 'Org. {org}',
  'ava.drawer.openFolder': 'Abrir toda la carpeta de conciliación',
  'ava.drawer.responsible': 'Responsable',
  'ava.drawer.deadline': 'Plazo',
  'ava.drawer.progress': 'Progreso',
  'ava.drawer.locked': 'El periodo está bloqueado. Para reabrirlo se necesita una justificación.',
  'ava.drawer.statusNote': 'El estado de cada área se deriva de las cuentas que contiene. No se establece aquí: un área no puede figurar como conciliada mientras una cuenta tenga una diferencia sin explicar.',
  'ava.drawer.filterTitle': 'Mostrar clientes con puntos abiertos en',
  'ava.drawer.clearAll': 'Quitar todos',
});
